import "dayjs/locale/es";
import "dayjs/locale/de";
import "dayjs/locale/de-ch";
import "dayjs/locale/de-at";
import "dayjs/locale/en-gb";
import "dayjs/locale/pt-br";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/it-ch";
import "dayjs/locale/fr-ch";
import "dayjs/locale/pt";
import "dayjs/locale/nl";
import "dayjs/locale/sv";
import "dayjs/locale/da";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMax from "dayjs/plugin/minMax";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import clamp from "./plugins/clamp";
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(weekday);
dayjs.extend(minMax);
dayjs.extend(weekOfYear);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(isToday);
dayjs.extend(clamp);
dayjs.extend(customParseFormat);
dayjs.locale("en-gb");
var dayjs_default = dayjs;
export {
  clamp,
  dayjs_default as default,
  isBetween,
  isSameOrAfter,
  isSameOrBefore,
  isToday,
  localeData,
  localizedFormat,
  minMax,
  utc,
  weekOfYear,
  weekday
};
